import React, { useState, useRef, useEffect, useContext } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Layout from '@/product/components/templates/Layout'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import Loaders from '@/product/components/molecules/Loaders'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    FormControl,
    FormControlLabel,
    FormLabel,
    Menu,
    MenuItem,
    Radio,
    RadioGroup,
    DialogTitle,
    Pagination,
    OutlinedInput,
    Select,
} from '@mui/material'
import './member.css'
import CheckBox from '@/product/components/atoms/CheckBox'
import { useHistory } from 'react-router-dom'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@emotion/react'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { handleRedirectInternal, mapData } from '@/product/common/components'
import NoRecordsFound from '@/product/components/atoms/NoRecordsFound'
import CardItem from './cardItem'
import BarCodeScan from './barcode'
import SettingContext from '@/custom/context/product/productContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import ReturnContext from '@/custom/context/return/returnContext'
import StepOne from './stepOne'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import StepTwo from './stepTwo'
import ProductContext from '@/product/context/product/productContext'
import { Buffer } from 'buffer'

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    }
}

const MemberView = (props) => {
    const settingcontext = useContext(SettingContext)
    const customCommonContext = useContext(CustomCommonContext)
    const history = useHistory()
    const returncontext = useContext(ReturnContext)
    const {
        getUserRequestCount,
        user_request_count,
        responseStatus: responseStatusRequest,
        clearResponse: clearResponseRequest,
    } = returncontext

    const productContext = useContext(ProductContext)
    const { changeProductStatus, responseStatus: responseStatusProduct } =
        productContext

    const { searchTableFetch, search_fetch_data } = settingcontext

    const { alldata_all_dropdown, allLocations, allCategory } =
        customCommonContext

    const [isLoading, setIsLoading] = useState(true)
    const [userRecords, setUserRecords] = useState([])
    const [userText, setUserText] = useState({
        id: '',
        name: '',
        not_picked_up: 0,
        picked_up: 0,
        pending_return: 0,
        success_return: 0,
        cancellled_return: 0,
        user_notes: '',
    })
    const videoConstraints = {
        width: 1280,
        height: 720,
        facingMode: 'environment',
    }
    const [itemsRecords, setItemsRecords] = useState([])
    const [pageRecords, setPageRecords] = useState({
        display: 0,
        totalRecords: 0,
    })
    const [anchorBreakEl, setAnchorBreakEl] = useState(false)
    const [open, setOpen] = useState(null)
    const [openApprove, setOpenApprove] = useState(null)
    const [initialStep, setInitialStep] = useState(true)
    const [stepOne, setStepOne] = useState(false)
    const [pid, setPid] = useState(0)
    const [cid, setCid] = useState(0)
    const [buynowId, setBuynowId] = useState(0)
    const [stepTwo, setStepTwo] = useState(false)
    const [denyActive, setDenyActive] = useState(false)
    const [moveDraft, setMoveDraft] = useState(false)
    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
    const [value, setValue] = React.useState('female')
    const [productLocation, setProductLocation] = useState({})
    const [scanToggle, setScanToggle] = useState(false)
    const [scanType, setScanType] = useState('user')
    const [locationData, setLocationData] = useState([])
    const [relistOpen, setRelistOpen] = useState(false)
    const [buttonIsSelected, setButtonIsSelected] = useState(false)
    const [bulkOpen, setBulkOpen] = useState(false)
    const isMobile = useMediaQuery('(max-width:767px)')
    const [itemNum, setItemNum] = useState('10')

    const handleRadioChange = (event) => {
        setValue(event.target.value)
    }
    const handleButtonToggle = () => {
        if (buttonIsSelected) {
            handleClearAll()
        } else {
            handleSelectAll()
        }
        setButtonIsSelected(!buttonIsSelected)
    }
    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleApproveClickOpen = () => {
        setOpenApprove(true)
    }

    const handleCancelOpen = () => {
        setOpen(false)
    }

    const handleDenyClickOpen = () => {
        setOpen(true)
        setDenyActive(true)
    }

    const handleClose = () => {
        setOpen(false)
        setOpenApprove(false)
    }

    const handleBreakClose = () => {
        setAnchorBreakEl(null)
    }
    const handleBreakClick = (event) => {
        setAnchorBreakEl(event.currentTarget)
    }
    const [expanded, setExpanded] = React.useState('panel0')

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : null)
        // if (panel === expanded) {
        //     setExpanded(false)
        // } else setExpanded(panel)
    }

    const handlePendingReturn = (pid, cid, bid, type) => {
        if (type === 'relist') {
            setStepOne(false)
            setStepTwo(true)
        } else {
            setStepTwo(false)
            setStepOne(true)
        }
        setPid(pid)
        setCid(cid)
        setBuynowId(bid)
        setInitialStep(false)
    }

    const handleMoveDraft = (event) => {
        event.currentTarget.classList.add('active')
        setOpen(true)
        setMoveDraft(true)
    }

    useEffect(() => {
        if (openApprove) {
            setStepOne(false)
            setInitialStep(false)
            // setStepTwo(true)
        }
    }, [openApprove])

    const uploadImgArray = [
        {
            orgImg: '/assets/images/proImg.png',
            alt: 'proImg',
        },
        {
            orgImg: '/assets/images/proImg.png',
            alt: 'proImg',
        },
        {
            orgImg: '/assets/images/proImg.png',
            alt: 'proImg',
        },
    ]

    const formatPhone = (phone, removeCountryCode = false) => {
        const countryCode = '+1'
        console.log('i am phone start ', phone)
        if (
            removeCountryCode &&
            (phone === '+1' ||
                phone === '1' ||
                phone === '+' ||
                phone === '' ||
                phone === null ||
                phone === '+10' ||
                phone === '0')
        ) {
            phone = ''
        } else if (
            removeCountryCode &&
            typeof phone === 'string' &&
            phone?.length
        ) {
            const regex = /\d+/g
            phone = phone.replace(/^\+?1\s?/, '')
            phone = phone.replace(/^\+/, '')
            const numbersArray = phone?.match(regex)
            const numbersString = numbersArray?.join('')
            phone = parseInt(numbersString, 10)
        } else {
            if (typeof phone === 'string' && !phone?.startsWith('+1')) {
                phone = `${countryCode}${phone}`
            } else {
                phone = `${countryCode}${phone}`
            }
        }
        console.log('i am phone return ', phone)
        return phone
    }

    const userFormik = useFormik({
        initialValues: {
            page: 1,
            limit: 10,
            order: '',
            sortData: true,
            orderby: 'b.pickup_deadline,asc',
            groupby: 'group by b.project_id',
            primaryTable: 'buynow',
            useCustomCountWithGroupBy: true,
            pick_up: '',
            tableJoins: [
                {
                    baseTable: 'users',
                    customTable: 'custom_users',
                    joinType: 'inner',
                    baseJoinField: 'id',
                    connectJoinField: 'user_id',
                },
                {
                    baseTable: 'projects',
                    customTable: 'custom_projects',
                    joinType: 'inner',
                    baseJoinField: 'id',
                    connectJoinField: 'project_id',
                },
            ],
            filters: {
                action: {
                    value: '',
                    type: 'in',
                    field: 'b.paid',
                },
                active: {
                    value: '2',
                    type: 'notin',
                    field: 'b.active',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'b.common_invoice',
                },
                pickedup_status: {
                    value: ['0', '2'],
                    type: '',
                    field: '',
                },
                buynow_user_id: {
                    value: '',
                    type: 'likewithstart',
                    field: 'u.phone,u.email,u.username',
                },
                user_id: {
                    value: '',
                    type: 'likewithstart',
                    field: 'u.phone,u.email,u.username',
                },
                project_id: {
                    value: '',
                    type: 'like',
                    field: 'b.project_id,p.title,p.item_id',
                },
                market_status: {
                    value: ['open', 'sold', 'closed', 'draft'],
                    type: 'array',
                    field: 'p.market_status',
                },
                location: {
                    value: [],
                    type: 'array',
                    field: 'it.location',
                },
            },
        },
        onSubmit: (values) => {
            values.groupby = 'group by b.project_id'
            if (values.pick_up === '6' || values.pick_up === '7') {
                values.filters.pickedup_status.value = []
                values.groupby = ''
            }
            // else {
            //     values.filters.pickedup_status.value = [
            //         '0',
            //         '1',
            //         '2',
            //         '3',
            //         '4',
            //         // '5',
            //         // '6',
            //         // '7',
            //     ]
            //     values.groupby = 'group by b.project_id'
            // }

            if (
                values.filters.user_id?.value &&
                typeof values.filters.user_id?.value === 'string'
            ) {
                const phoneRegex = /^\+?1?\d{10,}$|^\d{10,}$/
                const strippedValue = values.filters.user_id?.value?.replace(
                    /\D/g,
                    ''
                )
                if (phoneRegex.test(strippedValue)) {
                    // Only format the phone if it doesn't already start with +1
                    if (!values.filters.user_id.value?.startsWith('+1')) {
                        values.filters.user_id.value = formatPhone(
                            values.filters.user_id.value
                        )
                    }
                }
            }
            values.filters.buynow_user_id.value = values.filters.user_id.value
            const { location, ...filtersWithoutLocation } = values.filters
            values.sortDataFilter = filtersWithoutLocation
            console.log('i am form herererer submit', values)
            values.filters.buynow_user_id.value = values.filters.user_id.value
            setItemsRecords([])

            if (
                values.filters.pickedup_status.value.includes('7') ||
                values.filters.pickedup_status.value.includes('6') ||
                values.filters.pickedup_status.value?.length === 0
            ) {
                values.tableJoins = values.tableJoins.map((join) => {
                    if (join.baseTable === 'projects') {
                        return {
                            ...join,
                            joinType: 'right',
                        }
                    }
                    return join
                })
                values.filters.active.value = ''
                values.filters.project_id.field =
                    'b.project_id,p.title,p.id,p.item_id'
            }

            if (
                values.filters.user_id.value ||
                values.filters.project_id.value
            ) {
                // values.pick_up = ''
                setIsLoading(true)
                searchTableFetch({ ...values, pick_up: '' }, 'userRecords')
                if (
                    values.filters.user_id.value &&
                    values.filters.user_id.value !== ''
                ) {
                    getUserRequestCount({
                        user_id: values.filters.user_id.value,
                    })
                }
            } else if (values.pick_up != '') {
                setIsLoading(true)
                searchTableFetch(values, 'userRecords')
            } else {
                resetFormik()
                // setItemsRecords(
                //     search_fetch_data.records.length
                //         ? search_fetch_data.records
                //         : []
                // )
                // setPageRecords({
                //     display: search_fetch_data?.setDisp,
                //     totalRecords: search_fetch_data?.totalRecords,
                // })
            }
        },
    })

    const handleItemNumChange = (event) => {
        setItemNum(event.target.value)
        handleFilterChange('limit', event.target.value)
    }

    const resetFormik = async (type) => {
        console.log('i am here reset formik', type)
        closeScanDialogStatus()
        const resetType = type || scanType
        if (resetType === 'product') {
            // Store current values
            const updatedValues = { ...userFormik.values }
            // Update the form values
            updatedValues.filters.project_id.value = ''
            updatedValues.orderby = 'b.pickup_deadline,asc'
            updatedValues.pick_up = ''

            // Batch updates to avoid multiple renders
            await userFormik.setFieldValue('filters.project_id.value', '')
            await userFormik.setFieldValue('orderby', 'b.pickup_deadline,asc')
            await userFormik.setFieldValue('pick_up', '')

            // Instead of submitting the form, directly call the search function
            if (updatedValues.filters.user_id.value) {
                setIsLoading(true)
                searchTableFetch(updatedValues, 'userRecords')
            } else {
                // Reset without triggering a new search
                setItemsRecords([])
                setLocationData([])
                setPageRecords({ display: 0, totalRecords: 0 })
            }
        } else {
            userFormik.setFieldValue('filters.user_id.value', '')
            userFormik.setFieldValue('filters.buynow_user_id.value', '')
            userFormik.setFieldValue('orderby', 'b.pickup_deadline,asc')
            userFormik.setFieldValue('pick_up', '')
            setUserText({
                id: '',
                name: '',
                not_picked_up: 0,
                picked_up: 0,
                pending_return: 0,
                success_return: 0,
                cancellled_return: 0,
                user_notes: '',
            })
            setItemsRecords([])
            setLocationData([])
            setPageRecords({ display: 0, totalRecords: 0 })
        }
    }

    useEffect(() => {
        setItemsRecords([])
        setLocationData([])
        setPageRecords({ display: 0, totalRecords: 0 })
    }, [])

    useEffect(() => {
        if (user_request_count && user_request_count.records.length) {
            setUserText({
                id: user_request_count.records[0].id || '',
                name: user_request_count.records[0].users_name || '',
                user_notes: user_request_count.records[0].user_notes || '',
                not_picked_up: user_request_count.records[0].not_picked_up || 0,
                picked_up: user_request_count.records[0].picked_up || 0,
                pending_return:
                    user_request_count.records[0].pending_return || 0,
                success_return:
                    user_request_count.records[0].success_return || 0,
                cancellled_return:
                    user_request_count.records[0].cancellled_return || 0,
            })
        }
    }, [user_request_count])

    useEffect(() => {
        setIsLoading(false)
        if (
            search_fetch_data &&
            search_fetch_data.from === 'userRecords' &&
            search_fetch_data.records.length &&
            (userFormik.values.filters.user_id.value ||
                userFormik.values.filters.project_id.value ||
                userFormik.values.pick_up != '')
        ) {
            setItemsRecords(
                search_fetch_data.records.length
                    ? search_fetch_data.records
                    : []
            )
            setPageRecords({
                display: search_fetch_data?.setDisp,
                totalRecords: search_fetch_data?.totalRecords,
            })

            const userIdValue =
                userFormik?.values?.filters?.user_id?.value ?? ''
            // const isString = typeof userIdValue === 'string';

            if (
                userIdValue === '' &&
                search_fetch_data?.records?.length &&
                search_fetch_data?.records[0]?.user_id &&
                !userFormik?.values?.pick_up
            ) {
                userFormik.setFieldValue(
                    'filters.user_id.value',
                    search_fetch_data.records[0]?.users_email
                )
                getUserRequestCount({
                    user_id: search_fetch_data.records[0]?.users_email,
                })
            }
        } else {
            setItemsRecords([])
            setPageRecords({ display: 0, totalRecords: 0 })
        }
    }, [search_fetch_data])

    const updateFunction = () => {
        userFormik.values.page = 1
        searchTableFetch(userFormik.values, 'userRecords')
    }

    useEffect(() => {
        setLocationData([])
        if (allLocations.length) {
            let dropValues = allLocations
                .filter((main) => {
                    if (
                        main.active === 1 &&
                        (search_fetch_data &&
                        search_fetch_data.sorts &&
                        search_fetch_data.sorts.sortlocations
                            ? search_fetch_data.sorts.sortlocations?.includes(
                                  main.id.toString()
                              )
                            : false)
                    ) {
                        return true
                    }
                })
                .map((location) => {
                    let locationChanged = {}
                    locationChanged.show = location.name
                    locationChanged.value = location.id.toString()
                    locationChanged.id = location.id.toString()
                    locationChanged.description =
                        location.name || location.description || ''
                    return locationChanged
                })
            setLocationData(dropValues)
        } else {
            setLocationData([])
        }
    }, [allLocations, search_fetch_data?.sorts])

    const handleFilterChange = (field, value, filterdata, isArrayValue) => {
        if (field) {
            userFormik.setFieldValue(`page`, 1)
            if (filterdata) {
                if (Array.isArray(value) && value.length) {
                    userFormik.setFieldValue(`filters.${field}.value`, value)
                } else if (isArrayValue) {
                    userFormik.setFieldValue(`filters.${field}.value`, [])
                } else {
                    userFormik.setFieldValue(
                        `filters.${field}.value`,
                        value || ''
                    )
                }
            } else {
                if (Array.isArray(value) && value.length) {
                    userFormik.setFieldValue(`filters.${field}.value`, value)
                } else if (isArrayValue) {
                    userFormik.setFieldValue(`filters.${field}.value`, [])
                } else if (filterdata) {
                    userFormik.setFieldValue(
                        `filters.${field}.value`,
                        value || ''
                    )
                } else {
                    userFormik.setFieldValue(`${field}`, value || '')
                }
            }
            userFormik.handleSubmit()
        }
    }

    const filterSections = [
        {
            name: 'pickedup_status',
            type: 'checkbox',
            title: 'STATUS',
            filter: true,
            hidden:
                !userFormik.values.filters.user_id.value.length &&
                userFormik.values.filters.project_id.value == ''
                    ? true
                    : false,
            search_type: 'checkbox',
            item: [
                { id: '0', description: 'Not Picked Up' },
                { id: '1', description: 'Picked Up' },
                { id: '2', description: 'Pending Return' },
                { id: '3', description: 'Returned' },
                { id: '4', description: 'Need Relisted' },
                // { id: '5', description: 'Need Relisted' },
                // { id: '6', description: 'Draft Inventory' },
                // { id: '7', description: 'Live' },
            ],
            formik: userFormik,
            onChange: (event, value) => {
                handleFilterChange(`pickedup_status`, value, 1, false)
            },
        },
        {
            name: 'location',
            type: 'select',
            title: 'LOCATION',
            className: 'location-filter',
            search_type: 'checkbox',
            hidden: !locationData?.length,
            filter: true,
            item: locationData,
            onChange: (event, value) => {
                handleFilterChange(`location`, value, 1, true)
            },
        },
    ]

    const userSearchField = {
        formik: userFormik,
        data: [
            {
                label: 'Search Member',
                type: 'search',
                inputProps: { enterKeyHint: 'search' },
                placeholder: 'Search Members',
                class: 'col-12 p-0',
                name: 'user_id',
                filter: true,
                startAdornment: (
                    <span className="material-icons-outlined">search</span>
                ),
                endAdornment: userFormik.values.filters.user_id.value ? (
                    <span
                        className="material-icons-outlined"
                        onClick={(e) => {
                            // Prevent event bubbling
                            e.stopPropagation()
                            resetFormik('user')
                        }}
                    >
                        close
                    </span>
                ) : null,
            },
        ],
    }

    const statusShow = [
        { value: '0', show: 'Not Picked Up' },
        { value: '1', show: 'Picked Up' },
        { value: '2', show: 'Pending Return' },
        { value: '3', show: 'Returned' },
        { value: '4', show: 'Need Relisted' },
        // { value: '5', show: 'Need Relisted' },
        { value: '6', show: 'Draft Inventory' },
        { value: '7', show: 'Live' },
    ]

    const sortShow = [
        {
            value: 'b.id,desc',
            show: 'Recently Added',
        },
        {
            value: `l.full_address,asc`,
            show: 'Location A-Z',
        },
        {
            value: `l.full_address,desc`,
            show: 'Location Z-A',
        },
        {
            value: 'b.pickup_deadline,asc',
            show: 'Pickup Deadline: Soonest',
        },
        {
            value: 'b.pickup_deadline,desc',
            show: 'Pickup Deadline: Furthest',
        },
    ]

    const productSearchField = {
        formik: userFormik,
        data: [
            {
                label: 'Search Items',
                type: 'search',
                inputProps: { enterKeyHint: 'search' },
                placeholder: 'Search Items',
                class: 'col-xl-4 col-12 sortInput',
                name: 'project_id',
                filter: true,
                startAdornment: (
                    <span className="material-icons-outlined">search</span>
                ),
                endAdornment: userFormik.values.filters.project_id.value ? (
                    <span
                        className="material-icons-outlined"
                        style={{ cursor: 'pointer' }}
                        onClick={(e) => {
                            // Prevent event bubbling
                            e.stopPropagation()
                            resetFormik('product')
                        }}
                    >
                        close
                    </span>
                ) : null,
            },
            {
                label: 'Status Search',
                placeholder: 'Status Search',
                type: 'select',
                class: `col-xl-4 col-12 sortCol ${
                    userFormik.values.filters.user_id.value === '' &&
                    userFormik.values.filters.project_id.value === ''
                        ? ''
                        : 'd-none'
                }`,
                options: statusShow,
                name: 'pick_up',
                filter: false,
                native: true,
                // isNoDefaultOptionValue: false,
                onChange: (event, value) => {
                    handleFilterChange(`pick_up`, event.target.value)
                },
                // onChange: handlePickup,
            },
            {
                label: 'Sort:',
                placeholder: 'Sort:',
                type: 'select',
                class: `col-xl-4 col-12 sortCol ${
                    userFormik.values.filters.user_id.value !== '' ||
                    userFormik.values.filters.project_id.value !== ''
                        ? ''
                        : 'd-none'
                }`,
                options: sortShow,
                name: 'orderby',
                filter: false,
                isNoDefaultOptionValue: true,
            },
        ],
    }

    const fileValidationArray = Yup.object({
        file_path: Yup.array().when('content_type', {
            is: 'file',
            then: Yup.array().required('Required!'),
        }),
    })

    const fileFormik = useFormik({
        initialValues: {
            file_path: [],
        },
        validationSchema: fileValidationArray,
        onSubmit: (values) => {},
    })

    const changeScanDialogStatus = () => {
        fileFormik.resetForm()
        setScanToggle(!scanToggle)
    }

    const closeScanDialogStatus = () => {
        fileFormik.resetForm()
        setScanToggle(false)
    }

    const setDecodedBarcode = (data) => {
        if (data && data !== '') {
            console.log('i am scanned here ', scanType, data)
            if (scanType === 'product') {
                userFormik.values.filters.project_id.value = data
                userFormik.handleSubmit()
            } else if (scanType === 'bin_location') {
                formik.values.bin_location = data
            } else {
                userFormik.values.filters.user_id.value = data
                userFormik.handleSubmit()
            }
        }
    }

    const handleScanInput = (type) => {
        if (type === 'product') {
            setScanType('product')
        } else if (type === 'bin_location') {
            setScanType('bin_location')
        } else {
            setScanType('user')
        }
        setScanToggle(true)
    }

    const handleSelectAll = () => {
        if (locationData) {
            const locationIds = locationData.map((l) => l.id)
            userFormik.setFieldValue('filters.location.value', locationIds)
            userFormik.setFieldValue('filters.pickedup_status.value', [
                '0',
                '1',
                '2',
                '3',
                '4',
                // '5',
                // '6',
                // '7',
            ])
            userFormik.handleSubmit()
        }
    }

    const handleClearAll = () => {
        userFormik.setFieldValue('filters.location.value', [])
        userFormik.setFieldValue('filters.pickedup_status.value', [])
        userFormik.setFieldValue('pick_up', '')
        userFormik.handleSubmit()
    }

    const onHandlePage = (event, value) => {
        userFormik.setFieldValue('page', value)
        userFormik.handleSubmit()
    }

    const closeOne = (action) => {
        if (action === 'relist_open') {
            setStepOne(false)
            setStepTwo(true)
        } else {
            setStepTwo(false)
            setStepOne(false)
            setInitialStep(true)
            userFormik.handleSubmit()
        }
        // handleClearAll()
    }

    useEffect(() => {
        if (userFormik.values.orderby) {
            if (userFormik.values.orderby?.includes('full_address')) {
                userFormik.setFieldValue('tableJoins', [
                    ...userFormik.initialValues.tableJoins,
                    {
                        baseTable: 'locations',
                        joinType: 'left',
                        baseJoinField: 'id',
                        connectJoinField: 'location_id',
                        customTableJoin: 'projects',
                    },
                ])
            } else {
                userFormik.setFieldValue(
                    'tableJoins',
                    userFormik.initialValues.tableJoins
                )
            }

            // Only submit if there's an active search (user or product) and not during a reset operation
            if (
                (userFormik.values.filters.user_id.value ||
                    userFormik.values.filters.project_id.value) &&
                !userFormik.isSubmitting
            ) {
                userFormik.handleSubmit()
            }
        }
    }, [userFormik.values.orderby])

    useEffect(() => {
        if (userFormik.values.filters.project_id.value) {
            userFormik.setFieldValue(`page`, 1)
        }
    }, [userFormik.values.filters.project_id.value])

    useEffect(() => {
        // if (
        //     userFormik.values.pick_up === '6' ||
        //     userFormik.values.pick_up === '7'
        // ) {
        //     userFormik.setFieldValue('filters.pickedup_status.value', [])
        //     userFormik.setFieldValue('groupby', '')
        // } else {
        //     userFormik.setFieldValue('filters.pickedup_status.value', [
        //         '0',
        //         '1',
        //         '2',
        //         '3',
        //         '4',
        //         // '5',
        //         // '6',
        //         // '7',
        //     ])
        //     userFormik.setFieldValue('groupby', 'group by b.project_id')
        // }

        // Only submit the form if this is a user-initiated change, not a programmatic reset
        if (userFormik.values.pick_up !== '' && !userFormik.isSubmitting) {
            userFormik.handleSubmit()
        }
    }, [userFormik.values.pick_up])

    const needRelistFormik = useFormik({
        initialValues: {
            id: 0,
            user_id: 0,
            customMessage: 'Successfully Relisted',
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            action: 'relist',
            relist_type: 'relist',
        },
        onSubmit: (values) => {
            if (values?.id) {
                values.action = 'relist'
                values.relist_type = 'relist'
                setIsLoading(true)
                console.log(`payload changeProductStatus `, values)
                changeProductStatus(values, `relist`, true)
            }
        },
    })

    const handleNeedRelist = (productId, userId) => {
        console.log(`payload handleNeedRelist `, productId, userId)
        if (productId) {
            needRelistFormik.values.id = productId
            needRelistFormik.values.user_id = userId
            setRelistOpen(true)
        }
    }

    useEffect(() => {
        if (responseStatusProduct) {
            if (
                responseStatusProduct.status === 'success' &&
                responseStatusProduct?.from === 'relist'
            ) {
                closeOne()
            }
            if (
                responseStatusProduct.status === 'success' &&
                responseStatusProduct?.from === 'updateToSG'
            ) {
                setBulkOpen(false)
                userFormik.handleSubmit()
            }
        }
        setRelistOpen(false)
        setIsLoading(false)
    }, [responseStatusProduct])

    const validationArray = Yup.object().shape({
        id: Yup.number().positive().integer().required('Id is required'),
        bin_location: Yup.string()
            .required('Please enter a valid location in facility')
            .trim()
            .min(1, 'Location cannot be empty')
            .matches(/\S/, 'Location cannot contain only whitespace'),
    })
    const formik = useFormik({
        initialValues: {
            id: 0,
            bin_location: '',
            action: 'updateToSG',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            console.log(`payload changeProductStatus `, values)
            changeProductStatus(values, `updateToSG`, true)
        },
    })

    const handleMoveItem = (popup, id, bin_location) => {
        console.log('isisisisisi ', popup, id, bin_location)
        formik.values.id = id || 0
        formik.values.bin_location = bin_location || ''
        setBulkOpen(popup || false)
    }

    const onClickSwitchUser = (id) => {
        let btoa = Buffer.from(id.toString(), 'binary').toString('base64')
        window.open(
            `${process.env.REACT_APP_FRONTEND_URL}switch?user_id=${btoa}`,
            '_blank'
        )
    }

    return (
        <>
            <Layout>
                <div>
                    <div className="memberShipCardRoot mb-4">
                        <div className="memberShipScanRoot memberClassing">
                            <Button
                                onClick={() => handleScanInput('user')}
                                className="mb-3"
                            >
                                Member Scan
                                <img
                                    src="/assets/images/qr-code.webp"
                                    alt=""
                                    width="30"
                                />
                            </Button>
                            <div>{mapData(userSearchField)}</div>
                        </div>
                        {userText.name &&
                        userText.id !== '' &&
                        userFormik.values.filters.user_id.value !== '' ? (
                            <div className="mamberDetailsBox">
                                <div className="memberScanInfo">
                                    <div>Hello {userText.name}</div>
                                    {/* <div>SBorkdy124574</div> */}
                                    {userText.not_picked_up ? (
                                        <div>
                                            {userText.not_picked_up} Item
                                            {Number(
                                                userText?.not_picked_up || 0
                                            ) > 1
                                                ? 's'
                                                : ''}{' '}
                                            Not Picked Up
                                        </div>
                                    ) : null}
                                    {userText.picked_up ? (
                                        <div>
                                            {userText.picked_up} Item
                                            {Number(userText?.picked_up || 0) >
                                            1
                                                ? 's'
                                                : ''}{' '}
                                            Picked Up
                                        </div>
                                    ) : null}
                                    {userText.pending_return ? (
                                        <div>
                                            {userText.pending_return} Pending
                                            Return
                                            {userText?.pending_return === 1
                                                ? ''
                                                : 's'}
                                        </div>
                                    ) : null}
                                    {userText.success_return ? (
                                        <div>
                                            {userText.success_return} Successful{' '}
                                            {userText.success_return == 1
                                                ? 'Return'
                                                : 'Returns'}
                                        </div>
                                    ) : null}
                                    {userText.cancellled_return ? (
                                        <div>
                                            {userText.cancellled_return}{' '}
                                            Cancelled{' '}
                                            {userText.cancellled_return == 1
                                                ? 'Return'
                                                : 'Returns'}
                                        </div>
                                    ) : null}
                                </div>
                                {userText.user_notes ? (
                                    <p>Notes: {userText.user_notes}</p>
                                ) : null}
                                {userFormik.values.filters.user_id.value !==
                                    '' && userText.id !== '' ? (
                                    <span
                                        className="moredetails"
                                        onClick={() =>
                                            // handleRedirectInternal(
                                            //     history,
                                            //     `user/edit/${userText.id}`
                                            // )
                                            onClickSwitchUser(
                                                userText?.id || ''
                                            )
                                        }
                                    >
                                        More Account Details
                                    </span>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                    <div className="memberShipCardRoot">
                        <div className=" row">
                            <div className="memberShipScanRoot col-xl-9 col-12 needScanType">
                                <Button
                                    onClick={() => handleScanInput('product')}
                                    className="mb-3"
                                >
                                    Item Scan
                                    <img
                                        src="/assets/images/item-scan.webp"
                                        alt="barcode"
                                        height="30"
                                    />
                                </Button>

                                {mapData(productSearchField)}
                            </div>
                            <div className="col-xl-3 col-12"></div>
                        </div>

                        <>
                            {itemsRecords.length ||
                            userFormik.values.filters.user_id.value.length ||
                            userFormik.values.filters.project_id.value !== '' ||
                            userFormik.values.pick_up !== '' ? (
                                <div className="mamberCardDetailsBox row">
                                    <div className="col-xl-9">
                                        {isLoading ? (
                                            <>
                                                <div className="fspLoader">
                                                    <Loaders
                                                        isLoading={isLoading}
                                                    />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                {itemsRecords.length ? (
                                                    itemsRecords.map(
                                                        (product, index) => (
                                                            <CardItem
                                                                data={product}
                                                                index={index}
                                                                handlePendingReturn={
                                                                    handlePendingReturn
                                                                }
                                                                updateFunction={
                                                                    updateFunction
                                                                }
                                                                handleNeedRelist={
                                                                    handleNeedRelist
                                                                }
                                                                handleMoveItem={
                                                                    handleMoveItem
                                                                }
                                                            />
                                                        )
                                                    )
                                                ) : (
                                                    <NoRecordsFound />
                                                )}
                                            </>
                                        )}
                                        <div className="d-flex justify-content-between align-items-center flex-wrap w-100 my-3 pagination-wrapper position-relative">
                                            <h6>
                                                {'showing'}{' '}
                                                {pageRecords.display} {'of'}{' '}
                                                {pageRecords?.totalRecords}
                                            </h6>
                                            <Pagination
                                                count={Math.ceil(
                                                    pageRecords?.totalRecords /
                                                        userFormik.values.limit
                                                )}
                                                page={userFormik.values.page}
                                                onChange={onHandlePage}
                                                siblingCount={3}
                                                showFirstButton
                                                showLastButton
                                                boundaryCount={2}
                                            />
                                        </div>
                                        <div
                                            className="selectListOptions"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <p className="m-0">Item Per Page</p>
                                            <FormControl sx={{ m: 1, mt: 3 }}>
                                                <Select
                                                    displayEmpty
                                                    value={
                                                        userFormik.values.limit
                                                    }
                                                    onChange={
                                                        handleItemNumChange
                                                    }
                                                    input={<OutlinedInput />}
                                                    renderValue={(selected) => {
                                                        if (!selected) {
                                                            return '10'
                                                        }
                                                        return selected
                                                    }}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: {
                                                                maxHeight: 200,
                                                            },
                                                        },
                                                    }}
                                                    inputProps={{
                                                        'aria-label':
                                                            'Without label',
                                                    }}
                                                >
                                                    {[
                                                        '10',
                                                        '20',
                                                        '50',
                                                        '100',
                                                    ].map((value) => (
                                                        <MenuItem
                                                            key={value}
                                                            value={value}
                                                            style={getStyles(
                                                                value,
                                                                itemNum,
                                                                theme
                                                            )}
                                                        >
                                                            {value}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                    {itemsRecords.length ||
                                    userFormik.values.filters.user_id.value
                                        .length ||
                                    userFormik.values.filters.project_id
                                        .value !== '' ? (
                                        <div className="orderSummary col-xl-3">
                                            <div className="orderFilter">
                                                {filterSections.map(
                                                    (data, index) =>
                                                        !data.hidden ? (
                                                            <Accordion
                                                                square
                                                                expanded={
                                                                    expanded ===
                                                                    `panel${index}`
                                                                }
                                                                defaultExpanded={
                                                                    !isMobile
                                                                }
                                                                key={index}
                                                                className={
                                                                    data.className
                                                                }
                                                                onChange={handleChange(
                                                                    `panel${index}`
                                                                )}
                                                            >
                                                                <AccordionSummary
                                                                    expandIcon={
                                                                        <ExpandMoreIcon />
                                                                    }
                                                                    aria-controls="panel1d-content"
                                                                    id={`panel${index}d-header`}
                                                                >
                                                                    <h6
                                                                        className="accTitle"
                                                                        id={
                                                                            data.title
                                                                        }
                                                                    >
                                                                        {
                                                                            data.title
                                                                        }{' '}
                                                                    </h6>
                                                                </AccordionSummary>
                                                                <AccordionDetails>
                                                                    <ul>
                                                                        {data.item.map(
                                                                            (
                                                                                d,
                                                                                i
                                                                            ) => (
                                                                                <li
                                                                                    key={
                                                                                        i
                                                                                    }
                                                                                    style={{
                                                                                        display:
                                                                                            'flex',
                                                                                        alignItems:
                                                                                            'center',
                                                                                    }}
                                                                                >
                                                                                    <CheckBox
                                                                                        name={`filters.${data.name}.value`}
                                                                                        label={
                                                                                            d.description
                                                                                        }
                                                                                        checked={
                                                                                            userFormik.values.filters[
                                                                                                data
                                                                                                    .name
                                                                                            ]?.value?.indexOf(
                                                                                                d.id.toString()
                                                                                            ) !==
                                                                                            -1
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                        value={d?.id?.toString()}
                                                                                        onChange={(
                                                                                            event,
                                                                                            value
                                                                                        ) => {
                                                                                            if (
                                                                                                data.onChange
                                                                                            ) {
                                                                                                const {
                                                                                                    name,
                                                                                                    value,
                                                                                                } =
                                                                                                    event.target
                                                                                                const currentValues =
                                                                                                    userFormik
                                                                                                        .values
                                                                                                        .filters[
                                                                                                        data
                                                                                                            .name
                                                                                                    ]
                                                                                                        ?.value ||
                                                                                                    []
                                                                                                const newValue =
                                                                                                    currentValues.includes(
                                                                                                        value
                                                                                                    )
                                                                                                        ? currentValues.filter(
                                                                                                              (
                                                                                                                  v
                                                                                                              ) =>
                                                                                                                  v !==
                                                                                                                  value
                                                                                                          )
                                                                                                        : [
                                                                                                              ...currentValues,
                                                                                                              value,
                                                                                                          ].filter(
                                                                                                              (
                                                                                                                  v
                                                                                                              ) =>
                                                                                                                  v !==
                                                                                                                  ''
                                                                                                          )
                                                                                                data.onChange(
                                                                                                    event,
                                                                                                    newValue
                                                                                                )
                                                                                            } else {
                                                                                                if (
                                                                                                    data.filter
                                                                                                ) {
                                                                                                    userFormik.setFieldValue(
                                                                                                        `filters.${data.name}.value`,
                                                                                                        event
                                                                                                    )
                                                                                                } else {
                                                                                                    userFormik.setFieldValue(
                                                                                                        `${data.name}`,
                                                                                                        event
                                                                                                    )
                                                                                                }
                                                                                                // userFormik.handleChange()
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </li>
                                                                            )
                                                                        )}
                                                                    </ul>
                                                                </AccordionDetails>
                                                            </Accordion>
                                                        ) : null
                                                )}
                                                <div
                                                    className="clearAll d-flex justify-content-end"
                                                    style={{ gap: '10px' }}
                                                >
                                                    <span
                                                        onClick={() =>
                                                            handleSelectAll()
                                                        }
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        Select All
                                                    </span>
                                                    <span
                                                        onClick={() =>
                                                            handleClearAll()
                                                        }
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        Clear All
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            ) : null}
                        </>
                    </div>
                </div>
            </Layout>

            {stepOne && (
                <StepOne
                    pid={pid}
                    cid={cid}
                    bid={buynowId}
                    closeOne={closeOne}
                    open={stepOne}
                    handleClose={closeOne}
                />
            )}

            {stepTwo && (
                <StepTwo
                    pid={pid}
                    cid={cid}
                    bid={buynowId}
                    closeOne={closeOne}
                    open={stepTwo}
                    handleClose={closeOne}
                />
            )}

            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                className={`returnflowDialog ${openApprove && 'approved'}`}
            >
                <DialogContent className="p-0">
                    {/* <div className='formFields w-100'>
                        <label>New Location :</label>
                        <CustomInput placeholder="Defective / Doesn't Work"/>
                    </div> */}
                    {openApprove ? (
                        <div className="text-center">
                            <svg
                                width="69"
                                height="69"
                                viewBox="0 0 69 69"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="mb-4"
                            >
                                <g clipPath="url(#clip0_26_161)">
                                    <path
                                        d="M34.36 0C39.6897 0 44.7334 1.21422 49.24 3.37996C47.3954 4.83935 45.6849 6.24037 44.0913 7.58885C41.0557 6.48555 37.7809 5.88428 34.3659 5.88428C26.5026 5.88428 19.3808 9.0716 14.232 14.2262C9.07745 19.3808 5.89012 26.4968 5.89012 34.36C5.89012 42.2232 9.07745 49.3392 14.232 54.4938C19.3866 59.6484 26.5026 62.8357 34.3659 62.8357C42.2291 62.8357 49.3509 59.6484 54.4997 54.4938C59.6543 49.3392 62.8416 42.2232 62.8416 34.36C62.8416 32.492 62.6606 30.659 62.3162 28.8902C63.7931 26.9638 65.3051 25.0432 66.852 23.1402C68.0662 26.6544 68.7259 30.4313 68.7259 34.36C68.7259 43.8461 64.8789 52.439 58.6619 58.656C52.4449 64.873 43.8519 68.72 34.3659 68.72C24.8798 68.72 16.2869 64.873 10.0698 58.656C3.84697 52.439 0 43.8461 0 34.36C0 24.8739 3.84697 16.281 10.064 10.064C16.281 3.84697 24.874 0 34.36 0ZM18.3534 28.7151L26.7361 28.6041L27.3608 28.7676C29.0537 29.7425 30.6473 30.8575 32.1359 32.1184C33.21 33.029 34.2374 34.0214 35.2123 35.0955C38.2187 30.2562 41.4235 25.8138 44.8093 21.7275C48.5162 17.2501 52.4507 13.1871 56.5837 9.48023L57.401 9.165H66.5485L64.7038 11.214C59.0355 17.5127 53.8926 24.0216 49.2459 30.7349C44.5992 37.4539 40.4428 44.389 36.7476 51.5283L35.5976 53.7466L34.541 51.4875C32.5912 47.3019 30.2562 43.4608 27.4717 40.0283C24.6871 36.5958 21.4473 33.5486 17.6704 30.9567L18.3534 28.7151Z"
                                        fill="#01A601"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_26_161">
                                        <rect
                                            width="68.72"
                                            height="68.72"
                                            fill="white"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                            <DialogContentText>
                                <strong>Return Approved</strong>
                            </DialogContentText>
                        </div>
                    ) : denyActive ? (
                        <DialogContentText>
                            By clicking confirm, you are{' '}
                            <strong>denying</strong> the return. Your staff note
                            will be sent to the customer.
                        </DialogContentText>
                    ) : moveDraft ? (
                        <DialogContentText>
                            Are you sure that this item is ready to move to
                            drafts?
                        </DialogContentText>
                    ) : (
                        <DialogContentText>
                            By clicking confirm, you are{' '}
                            <strong>approving</strong> the return and processing
                            a refund for this item.
                        </DialogContentText>
                    )}
                </DialogContent>
                {openApprove ? null : moveDraft ? (
                    <DialogActions className="justify-content-center mt-3">
                        <Button type="submit" className="PrimaryButton">
                            Confirm
                        </Button>
                        <Button type="submit" className="SecondaryButton">
                            Cancel
                        </Button>
                    </DialogActions>
                ) : (
                    <DialogActions className="justify-content-center mt-3">
                        <Button
                            type="submit"
                            className="PrimaryButton"
                            onClick={handleApproveClickOpen}
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                )}
            </Dialog>

            {/* Needs Relist Popup */}
            <Dialog
                open={relistOpen}
                onClose={() => {
                    setRelistOpen(false)
                }}
                className="returnflowDialog proEditView relistModal"
            >
                <>
                    <div className="d-flex justify-content-end">
                        <Button
                            className="material-symbols-outlined modalClosePerment editCancelModel relistModalClose"
                            onClick={() => {
                                setRelistOpen(false)
                            }}
                        >
                            <span className="material-icons">cancel</span>
                        </Button>
                    </div>
                    <DialogContent style={{ padding: 15 }}>
                        <div className="formFields">
                            <p className="text-center">
                                Are you sure that this item to be relisted?
                            </p>
                        </div>
                        <div className="actionBtnGrops text-center mt-1">
                            <Button
                                className="primaryButton"
                                onClick={() => needRelistFormik.handleSubmit()}
                            >
                                Submit
                            </Button>
                        </div>
                    </DialogContent>
                </>
            </Dialog>

            <BarCodeScan
                scanType={scanType}
                scanToggle={scanToggle}
                changeScanDialogStatus={closeScanDialogStatus}
                setDecodedBarcode={setDecodedBarcode}
                videoConstraints={videoConstraints}
            />

            {/* Bulk Move Popup */}
            <Dialog
                open={bulkOpen}
                onClose={() => {
                    setBulkOpen(false)
                }}
                className="returnflowDialog proEditView"
            >
                <>
                    <div className="d-flex justify-content-between moveToLoacation">
                        <DialogTitle>Move to Location</DialogTitle>
                        <Button
                            className="material-symbols-outlined modalClosePerment editCancelModel"
                            onClick={() => {
                                setBulkOpen(false)
                            }}
                        >
                            <span className="material-icons">cancel</span>
                        </Button>
                    </div>
                    <DialogContent style={{ padding: 15 }}>
                        <div className="text-left returnInfoListGet proEditView">
                            <div className="formFields  w-sm-100">
                                <label className="titleLabel">
                                    New Location :
                                </label>
                                <CustomInput
                                    type="text"
                                    name={`bin_location`}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik?.values?.bin_location}
                                    error={Boolean(
                                        formik.touched.bin_location &&
                                            formik.errors.bin_location
                                    )}
                                    helperText={
                                        formik.touched.bin_location &&
                                        formik.errors.bin_location
                                    }
                                    placeholder="Enter Location in facility"
                                    endAdornment={
                                        <span
                                            className="material-symbols-outlined"
                                            onClick={() =>
                                                handleScanInput('bin_location')
                                            }
                                            style={{
                                                cursor: 'pointer',
                                            }}
                                        >
                                            barcode_scanner
                                        </span>
                                    }
                                />
                            </div>
                        </div>
                        <div className="actionBtnGrops text-center mt-1">
                            <Button
                                // type="submit"
                                onClick={async () => {
                                    formik.handleSubmit()
                                }}
                                className="primaryButton"
                            >
                                Submit
                            </Button>
                        </div>
                    </DialogContent>
                </>
            </Dialog>
        </>
    )
}
export default MemberView
